import React, { Component } from "react";
import axios from "../../utils/new_request";
import { withRouter } from "react-router-dom";
// import { browserHistory } from 'react-router';  // 确保你安装并引入了 react-router
import Modal from "../component/modal"; // 引入 Modal 组件
import unSelectImg from "../../static/img/mutiselect_defult.svg";
import selectedImg from "../../static/img/mutiselect_checked.svg";
import radioCheckedImg from "../../static/img/radio_checked.png";
import radioDefultImg from "../../static/img/radio_default.png";
import addIcon from "../../static/img/xkCoach/icon-add.svg";
import deleteIcon from "../../static/img/xkCoach/icon-delete.svg";
import { Slider } from "antd"; // 引入 Slider 组件

import RegionModal from "./RegionModal"; // 确保路径正确
import ProvinceModal from "./ProvinceModal";
import YearModal from "./YearModal";
import TagModal from "./TagModal";

import Header from "../component/header";

import { xbagUrl, frontPathRoot } from "constant/constant";
import "./SelectSubject.less";
import "./overview.less";

import {
    createUUID,
    getFirstErrorKeyValue,
    getLocalData,
    getLocalDataTimeLimit,
    getUrlParam,
    hasUserDetail,
    setLocalData,
    setLocalDataTimeLimit,
    setSessionData,
    unixTimesTamp,
} from "utils/util";

const combinationList = [
    {
        id: 1,
        title: "物理组",
        children: [
            { id: [25, 26, 27], name: "物化生" },
            { id: [25, 26, 30], name: "物化地" },
            { id: [25, 26, 31], name: "物化政" },
            { id: [25, 27, 30], name: "物生地" },
            { id: [25, 27, 31], name: "物生政" },
            { id: [25, 30, 31], name: "物地政" },
        ],
    },
    {
        id: 2,
        title: "历史组",
        children: [
            { id: [29, 26, 27], name: "历化生" },
            { id: [29, 26, 30], name: "历化地" },
            { id: [29, 26, 31], name: "历化政" },
            { id: [29, 27, 30], name: "历生地" },
            { id: [29, 27, 31], name: "历生政" },
            { id: [29, 30, 31], name: "历地政" },
        ],
    },
];

const combinationList3_3 = [
    { id: 25, name: "物理", shortName: "物" },
    { id: 26, name: "化学", shortName: "化" },
    { id: 27, name: "生物", shortName: "生" },
    { id: 29, name: "历史", shortName: "历" },
    { id: 30, name: "地理", shortName: "地" },
    { id: 31, name: "政治", shortName: "政" },
];

const combinationList7_3 = [
    { id: 25, name: "物理" },
    { id: 26, name: "化学" },
    { id: 27, name: "生物" },
    { id: 28, name: "技术" },
    { id: 29, name: "历史" },
    { id: 30, name: "地理" },
    { id: 31, name: "政治" },
];

class SelectSubject extends Component {
    constructor() {
        super();
        this.state = {
            selectProvinceId: 110000,
            selectYear: 2024,
            maxYear: 2025,
            provinceList: [],
            yearsList: [],
            allProvinceList: [],
            emptyProvince: false,
            // 是否展示底部组件
            showCombinationModal: false,
            showProvinceModal: false,
            showYearModal: false,
            showTagModal: false,
            tagOptions: [
                { id: "985", name: "985" },
                { id: "211", name: "211" },
                { id: "双一流", name: "双一流" },
            ],
            combinationList: [],
            selectedCombinationList: [],
            selectedGroupList: [{ index: 0, id: [] }],
            errTips: "",
            showMaximumLimit: false,
            selectionMode: "condition", // 添加选择模式状态
            selectedTags: [], // 添加状态跟踪所选标签
            selectedRegions: [], // 添加状态跟踪所选地区
            showTagOptions: false, // 添加状态控制标签选项显示
            showRegionOptions: false, // 添加状态控制地区选项显示
            tempSelectedTags: [], // 用于临时保存选择的标签
            tempSelectedRegions: [], // 用于临时保存选择的地区
            selectedScoreRange: {},
            scoreMax: 0,
            scoreMin: 0,
            scoreTypeList: [{ id: 0, name: "不限" }],
            selectedScoreType: 0,
            totalRankingList: [],
            scoreRankingList: [],
            showScoreModal: false,
            showScoreSummary: false, // 用于控制是否显示分数总结
            showSchoolRegionSummary: false, // 用于控制是否显示院校地区总结
            showSchoolTagSummary: false, // 用于控制是否显示院校标签总结
            selectedMinScore: 0, // 用于存储最低分
            selectedMaxScore: 0, // 用于存储最高分
            analysisData: {},
            analysisData2: {},
            loading: false,
            scoreTypeName: {
                0: "不限",
                10: "文科",
                20: "理科",
                30: "物理组",
                40: "历史组",
                50: "综合类",
            },
            selectedMajorList: [],
            selectedSchoolList: [],
            tempSelectedProvince: null, // 用于临时保存选择的省份
            tempSelectedYear: null, // 用于临时保存选择的年份,
            allXkMode: [],
            currentExplainItem: null,
            showExplainModal: false,
            submitButtonDisabled: false
        };
        this.exlainList = [
            { id: 1, title: "选择高考省份", content: "请选择院校省份" },
            { id: 2, title: "选择高考年份", content: "请选择高考年份" },
            {
                id: 3,
                title: "请选择选科组合",
                content: "请至少选择1个选科组合",
            },
        ];
    }

    componentDidMount() {
        axios.get("/xbag/area/province/gets/withcity").then((d) => {
            if (d.errMsg || d.message) {
                this.setState({ errMsg: d.errMsg || d.message });
            } else {
                this.setState({ allProvinceList: d });
            }
        });
        axios.get("/xbag/college/purpose/xk_coach/province/years", {}).then((d) => {
            if (d.errMsg || d.message) {
                this.setState({ errMsg: d.errMsg || d.message });
            } else {
                this.setState({ provinceList: d });
                setLocalData("disabledOperation", true);
                axios
                    .get("/xbag/college/xkMode", {
                        year: this.state.selectYear,
                    })
                    .then((mode) => {
                        if (mode.errMsg || mode.message) {
                            this.setState({
                                errMsg: mode.errMsg || mode.message,
                            });
                        } else {
                            // 先保留所有的选科模式，方便后面切换
                            this.setState({ allXkMode: mode });
                            // 这里需要改成本地的那个年份
                            let xkMode = mode.filter((i) => i.provinceId == this.state.selectProvinceId)[0];
                            setSessionData("xkMode", xkMode ? xkMode.mode : 1);
                            let yearsList = [],
                                allYearsList = [];
                            d.forEach((i) => {
                                i.years.forEach((y) => {
                                    allYearsList.push(y);
                                });
                            });
                            let maxYear = Math.max(...Array.from(new Set(allYearsList)));
                            if (d.filter((i) => i.id == this.state.selectProvinceId)[0]) {
                                yearsList = d.filter((i) => i.id == this.state.selectProvinceId)[0].years;
                                let minYear = Math.min(...yearsList);
                                yearsList = this.generateSequence(minYear, maxYear).sort((a, b) => b - a);
                            }
                            // console.log("获取到的xkMode", xkMode )
                            this.setState({
                                xkMode: xkMode ? xkMode.mode : 1,
                                loading: false,
                                yearsList,
                                maxYear,
                            });
                        }
                    });
            }
        });

        const storedQueryData = localStorage.getItem("queryData");
        var selectedGroupList = [{ index: 0, id: [] }];
        if (storedQueryData) {
            const queryData = JSON.parse(storedQueryData);

            if (queryData.selectedCombinationList && queryData.selectedCombinationList.length > 0) {
                selectedGroupList = queryData.selectedCombinationList.map((comb, index) => ({
                    index,
                    id: comb,
                }));
            }
            this.setState({
                selectProvinceId: queryData.selectProvinceId,
                selectYear: queryData.selectYear,
                selectedCombinationList: queryData.selectedCombinationList,
                selectedMinScore: queryData.selectedMinScore,
                selectedMaxScore: queryData.selectedMaxScore,
                showScoreSummary: queryData.selectedMaxScore > 0,
                selectedRegions: queryData.selectedRegions,
                showSchoolRegionSummary: queryData.selectedRegions.length > 0,
                selectedScoreRange: queryData.selectedScoreRange,
                selectedScoreType: queryData.selectedScoreType,
                selectedTags: queryData.selectedTags,
                showSchoolTagSummary: queryData.selectedTags > 0,
                selectedGroupList, // 初始化 selectedGroupList
                selectedMajorList: queryData.selectedMajorList,
                selectedSchoolList: queryData.selectedSchoolList,
                selectionMode: queryData.selectionMode,
            });
        } else {
            // 初始化一个queryData
            const queryData = {
                selectProvinceId: 110000,
                selectYear: 2024,
                selectedCombinationList: [],
                selectedGroupList: [{ index: 0, id: [] }],
                selectedMinScore: 0,
                selectedMaxScore: 0,
                selectedScoreRange: {},
                selectedScoreType: 0,
                selectedRegions: [],
                selectedTags: [],
                selectedMajorList: [],
                selectedSchoolList: [],
                selectionMode: "condition",
            };
            localStorage.setItem("queryData", JSON.stringify(queryData));
        }
    }

    generateSequence = (start, end) => {
        let sequence = [];
        for (let i = start; i < end + 1; i++) {
            sequence.push(i);
        }
        return sequence;
    };

    selectProvincesChange = (event) => {
        const value = event.target.value;
        if (value != 0) {
            const curItem = this.state.provinceList.filter((item) => item.id == value);
            if (curItem.length > 0) {
                let { maxYear } = this.state;
                let minYear = Math.min(...curItem[0].years);
                let yearsList = this.generateSequence(minYear, maxYear).sort((a, b) => b - a);
                this.setState({
                    selectYear: yearsList[0],
                    yearsList,
                    selectProvinceId: curItem[0].id,
                    emptyProvince: false,
                    selectedScoreType: 0,
                    xkMode: this.state.allXkMode.filter((i) => i.provinceId == curItem[0].id)[0].mode,
                });
            } else {
                const emptyItem = this.state.allProvinceList.filter((item) => item.id == value);
                this.setState({
                    selectYear: 0,
                    yearsList: [],
                    selectProvinceId: emptyItem[0].id,
                    selectedScoreType: 0,
                    emptyProvince: true,
                });
            }
        } else {
            this.setState({
                selectYear: 0,
                yearsList: [],
                selectProvinceId: 0,
            });
        }
    };

    selectYearsChange = (e) => {
        this.setState({
            selectYear: e.target.value,
        });
    };

    handleShowExplainModal = (id) => {
        let currentItem = this.exlainList.filter((i) => i.id == id)[0];
        this.setState({
            currentExplainItem: currentItem,
            showExplainModal: true,
        });
    };

    // 处理标签选择
    handleTagToggle = (tag) => {
        const { tempSelectedTags } = this.state;
        if (tempSelectedTags.includes(tag)) {
            this.setState({
                tempSelectedTags: tempSelectedTags.filter((t) => t !== tag),
            });
        } else {
            this.setState({ tempSelectedTags: [...tempSelectedTags, tag] });
        }
    };

    // 确认标签选择
    confirmTagSelection = () => {
        this.setState({
            selectedTags: this.state.tempSelectedTags,
            showTagModal: false,
        });
    };

    // 关闭标签选择
    closeTagOptions = () => {
        this.setState({ showTagModal: false });
    };

    // 打开关闭省份选择 Modal
    toggleProvinceOptions = () => {
        this.setState({
            showProvinceModal: !this.state.showProvinceModal,
            tempSelectedProvince: this.state.selectProvinceId, // 打开时初始化临时选择
        });
    };

    // 打开关闭年份选择 Modal
    toggleYearOptions = () => {
        this.setState({ showYearModal: !this.state.showYearModal });
    };

    // 处理省份选择
    handleProvinceChange = (id) => {
        this.setState({ tempSelectedProvince: id }, () => {
            this.selectProvincesChange({ target: { value: id } }); // 更新年份列表
        });
    };

    // 确认省份选择
    confirmProvinceSelection = () => {
        this.setState({
            showProvinceModal: false,
            selectProvinceId: this.state.tempSelectedProvince, // 确认时应用选择
        });
    };

    toggleYearOptions = () => {
        this.setState({
            showYearModal: !this.state.showYearModal,
            tempSelectedYear: this.state.selectYear, // 打开时初始化临时选择
        });
    };

    // 处理年份选择
    handleYearChange = (year) => {
        this.setState({ tempSelectedYear: year });
    };

    // 确认年份选择
    confirmYearSelection = () => {
        this.setState({
            showYearModal: false,
            selectYear: this.state.tempSelectedYear, // 确认时应用选择
        });
    };

    handleRegionToggle = (region) => {
        const { tempSelectedRegions } = this.state;
        if (tempSelectedRegions.includes(region)) {
            this.setState({
                tempSelectedRegions: tempSelectedRegions.filter((r) => r !== region),
            });
        } else {
            this.setState({
                tempSelectedRegions: [...tempSelectedRegions, region],
            });
        }
    };

    confirmRegionSelection = () => {
        this.setState({
            selectedRegions: this.state.tempSelectedRegions,
            showRegionOptions: false,
            showSchoolRegionSummary: true,
        });
    };

    closeRegionOptions = () => {
        this.setState({ showRegionOptions: false });
    };

    toggleTagOptions = () => {
        this.setState({
            showTagModal: !this.state.showTagModal,
            tempSelectedTags: [...this.state.selectedTags],
        });
    };

    toggleRegionOptions = () => {
        this.setState({
            showRegionOptions: !this.state.showRegionOptions,
            tempSelectedRegions: this.state.selectedRegions, // 打开时初始化临时选择
        });
    };

    handleSchoolWishListClick = () => {
        this.props.history.push("/xkcoach/schoolwishlist", this.state);
    };

    handleMajorWishListClick = () => {
        this.props.history.push("/xkcoach/majorwishlist", this.state);
    };

    handleClickCombination_3_1_2 = (item) => {
        let { selectedCombinationList } = this.state;
        let index = selectedCombinationList.findIndex((comb) => JSON.stringify(comb) === JSON.stringify(item));
        if (index !== -1) {
            selectedCombinationList.splice(index, 1);
            this.setState({ showMaximumLimit: false });
        } else {
            if (selectedCombinationList.length < 3) {
                selectedCombinationList.push(item);
            } else {
                this.setState({ showMaximumLimit: true });
            }
        }
        this.setState({ selectedCombinationList });
    };

    handleClickCombination_3_3 = (subjectId, groupIndex) => {
        let { selectedGroupList } = this.state;
        selectedGroupList.forEach((i) => {
            if (i.index == groupIndex) {
                let index = i.id.indexOf(subjectId);
                if (index != -1) {
                    i.id.splice(index, 1);
                    this.setState({ errTips: "" });
                } else {
                    if (i.id.length < 3) {
                        i.id.push(subjectId);
                        this.setState({ errTips: "" });
                    } else {
                        this.setState({ errTips: "每个组合最多选择三个科目" });
                    }
                }
            }
        });
        this.setState({ selectedGroupList });
    };

    handleAddGroup = () => {
        let { selectedGroupList } = this.state;
        let length = selectedGroupList.length;
        if (selectedGroupList.length < 3) {
            let newItem = {
                index: selectedGroupList[length - 1].index + 1,
                id: [],
            };
            selectedGroupList.push(newItem);
        }
        this.setState({ selectedGroupList });
    };

    handleDeleteGroup = (groupIndex) => {
        let { selectedGroupList } = this.state;
        selectedGroupList.splice(groupIndex, 1);
        this.setState({ selectedGroupList });
    };

    handleConfirm_3_1_2 = () => {
        let { selectedCombinationList } = this.state;
        // console.log("selectedCombinationList", selectedCombinationList);
        if (selectedCombinationList.length == 0) {
        } else {
            this.setState({
                selectedCombinationList,
                // selectedGroupList, // 更新 selectedGroupList 状态
                showCombinationModal: false,
                errTips: "",
            });
        }
    };

    handleConfirm_3_3 = () => {
        let { selectedGroupList } = this.state;
        let selectedCombinationList = [];
        selectedGroupList.forEach((i) => {
            if (i.id.length == 3) {
                i.id.sort((a, b) => a - b);
                selectedCombinationList.push(i.id);
            }
        });
        if (selectedGroupList.length != selectedCombinationList.length) {
            this.setState({ errTips: "请完善你的选科组合" });
        } else {
            this.setState({
                selectedCombinationList,
                selectedGroupList, // 更新 selectedGroupList 状态
                showCombinationModal: false,
                errTips: "",
            });
        }
    };

    handleSelectionModeChange = (e) => {
        this.setState({ selectionMode: e.target.value });
    };

    dealScoreline = (selectedScoreType) => {
        let { scoreTypeList, totalRankingList } = this.state;
        if (scoreTypeList.length !== 0) {
            axios
                .get("/xbag/college/score/ranking/list", {
                    provinceId: this.state.selectProvinceId,
                })
                .then((rankingList) => {
                    if (rankingList.errMsg || rankingList.message) {
                        this.setState({
                            scoreMax: 0,
                            scoreMin: 0,
                            scoreRankingList: [],
                            scoreRange: [],
                        });
                    } else {
                        let repeatBranchList = rankingList.map((i) => {
                            return i.branch;
                        });
                        let branchList = Array.from(new Set(repeatBranchList));
                        let newScoreTypeList = [{ id: 0, name: "不限" }];
                        branchList.map((i) => {
                            if (i == 10) newScoreTypeList.push({ id: 10, name: "文科" });
                            if (i == 20) newScoreTypeList.push({ id: 20, name: "理科" });
                            if (i == 30)
                                newScoreTypeList.push({
                                    id: 30,
                                    name: "物理组",
                                });
                            if (i == 40)
                                newScoreTypeList.push({
                                    id: 40,
                                    name: "历史组",
                                });
                            if (i == 50)
                                newScoreTypeList.push({
                                    id: 50,
                                    name: "综合类",
                                });
                        });
                        this.setState({
                            scoreTypeList: newScoreTypeList,
                            totalRankingList: rankingList,
                        });
                        if (selectedScoreType != 0) {
                            let arr = rankingList.filter((i) => i.branch == selectedScoreType);
                            arr.sort((a, b) => {
                                return a.scoreFrom - b.scoreFrom;
                            });
                            let total = arr.length;
                            this.setState({
                                scoreMax: arr[total - 1].scoreFrom,
                                scoreMin: arr[0].scoreFrom,
                                scoreRankingList: arr,
                                scoreRange: [arr[0].scoreFrom, arr[total - 1].scoreFrom],
                            });
                        }
                    }
                });
        } else {
            if (selectedScoreType != 0) {
                let arr = totalRankingList.filter((i) => i.branch == selectedScoreType);
                arr.sort((a, b) => {
                    return a.scoreFrom - b.scoreFrom;
                });
                let total = arr.length;
                this.setState({
                    scoreMax: arr[total - 1].scoreFrom,
                    scoreMin: arr[0].scoreFrom,
                    scoreRankingList: arr,
                });
            }
        }
        this.setState({ showScoreModal: true });
    };

    handleSelectScoreType = (id) => {
        let { totalRankingList } = this.state;
        if (id != 0) {
            let arr = totalRankingList.filter((i) => i.branch == id);
            arr.sort((a, b) => {
                return a.scoreFrom - b.scoreFrom;
            });
            let total = arr.length;
            this.setState({
                scoreMax: arr[total - 1].scoreFrom,
                scoreMin: arr[0].scoreFrom,
                scoreRankingList: arr,
                scoreRange: [arr[0].scoreFrom, arr[total - 1].scoreFrom],
            });
        }
        this.setState({ selectedScoreType: id });
    };

    sliderFormatter = (e) => {
        let { scoreRankingList, xkMode } = this.state;
        if (xkMode == 1 || xkMode == 3) {
            if (e < 390) {
                let rank =
                    scoreRankingList.filter((i) => i.scoreFrom <= e && i.scoreTo >= e)[0] &&
                    scoreRankingList.filter((i) => i.scoreFrom <= e && i.scoreTo >= e)[0].ranking;
                return (
                    <div className='tooltip-inner'>
                        <p>分数/省排名</p>
                        <p>
                            {e}/{rank || 0}
                        </p>
                    </div>
                );
            } else {
                let rank =
                    scoreRankingList.filter((i) => i.scoreFrom == e)[0] &&
                    scoreRankingList.filter((i) => i.scoreFrom == e)[0].ranking;
                return (
                    <div className='tooltip-inner'>
                        <p>分数/省排名</p>
                        <p>
                            {e}/{rank || 0}
                        </p>
                    </div>
                );
            }
        } else {
            let rank =
                scoreRankingList.filter((i) => i.scoreFrom == e)[0] &&
                scoreRankingList.filter((i) => i.scoreFrom == e)[0].ranking;
            return (
                <div className='tooltip-inner'>
                    <p>分数/省排名</p>
                    <p>
                        {e}/{rank || 0}
                    </p>
                </div>
            );
        }
    };

    handleConfirmScore = () => {
        let { scoreRange, selectedScoreType, scoreRankingList, selectProvinceId, selectYear, selectedCombinationList } =
            this.state;
        let item = {};
        item.branch = selectedScoreType;
        item.minScore = scoreRange[0];
        item.minRank =
            scoreRankingList.filter((i) => i.scoreFrom == scoreRange[0])[0] &&
            scoreRankingList.filter((i) => i.scoreFrom == scoreRange[0])[0].ranking;
        item.maxScore = scoreRange[1];
        item.maxRank =
            scoreRankingList.filter((i) => i.scoreFrom == scoreRange[1])[0] &&
            scoreRankingList.filter((i) => i.scoreFrom == scoreRange[1])[0].ranking;
        
        this.setState(
            {
                selectedScoreRange: item || {},
                showScoreModal: false,
                showScoreSummary: true, // 显示分数总结
                selectedMinScore: scoreRange[0], // 更新最低分
                selectedMaxScore: scoreRange[1], // 更新最高分
            },
            () => {
                // this.getAnalysisData(selectProvinceId, selectYear, [], p || {}, selectedCombinationList);
            }
        );
    };

    handleEditScore = () => {
        let { selectedScoreType } = this.state;
        this.dealScoreline(selectedScoreType);
    };

    handleCombinationeModal = () => {
        let { selectProvinceId, year } = this.state;
        if (selectProvinceId === 0 || year === 0) {
            if (selectProvinceId === 0) {
                alert("请先选择高考省份");
            }
            if (year === 0) {
                alert("请选择高考年份");
            }
            return;
        } else {
            this.setState({ showCombinationModal: true });
        }
    };

    handleQuery = () => {
        const {
            selectProvinceId,
            selectYear,
            selectedScoreRange,
            selectedCombinationList,
            selectedMinScore,
            selectedMaxScore,
            scoreTypeList,
            allProvinceList,
            selectedRegions,
            selectedScoreType,
            selectedTags,
            tagOptions,
            tempSelectedTags,
            selectedSchoolList,
            selectedMajorList,
            selectedGroupList,
            selectionMode,
        } = this.state;

        if (selectProvinceId === 0 || selectYear === 0 || selectedCombinationList.length === 0) {
            // 分别判断三个条件是否为空，给出不同的提示
            if (selectProvinceId === 0) {
                this.handleShowExplainModal(1);
            } else if (selectYear === 0) {
                this.handleShowExplainModal(2);
            } else if (selectedCombinationList.length === 0) {
                this.handleShowExplainModal(3);
            }
            return;
        }
        this.setState({ submitButtonDisabled: true });
        this.getAnalysisData().then(({ analysisData }) => {
            // 保证高考省份，高考年份，选科组合这三个都有值，如果没有，就不跳转，并且给出提示

            const queryData = {
                selectProvinceId,
                selectYear,
                selectedCombinationList,
                selectedGroupList,
                selectedMinScore,
                selectedMaxScore,
                selectedScoreRange,
                analysisData,
                scoreTypeList,
                selectedRegions,
                selectedScoreType,
                selectedTags,
                selectedSchoolList,
                selectedMajorList,
                selectionMode,
            };

            // 存储数据到 localStorage
            localStorage.setItem("queryData", JSON.stringify(queryData));
            this.props.history.push("/SelectSubjectResult", this.state);
        });
    };

    handleClearMajorSelection = () => {
        this.setState({ selectedMajorList: [] });
    };

    getAnalysisData = () => {
        const {
            // 高考省份
            selectProvinceId,
            // 高考年份
            selectYear,
            // 院校选择方式
            selectionMode,
            // 意向院校
            selectedSchoolList,
            // 意向专业
            selectedMajorList,
            // 院校地区
            selectedRegions,
            // 院校分数
            selectedScoreRange,
            // 院校标签
            selectedTags,
            // 选科组合
            selectedCombinationList,
        } = this.state;

        // todo: 判断当前页面用的是哪种方式的院校选择，根据不同方式传不同的参数
        // 1、可以删掉所有的analysisdata2
        // 2、useIntentionUniversities也可以不要

        // const { selectProvinceId, selectYear } = this.state;

        let item = {};
        item.provinceId = selectProvinceId;
        item.year = selectYear;
        item.intentionSubjects = selectedCombinationList;
        item.intentionSpecialtyList = selectedMajorList.map((i) => i.id);

        if (selectionMode === "specific") {
            item.universityIds = selectedSchoolList.map((i) => i.id);
        } else {
            item.tags = selectedTags;
            item.regions = {};
            item.intentionScoreline = selectedScoreRange;
        }

        return Promise.all([axios.post(`/xbag/college/purpose/xk_coach/analysis/without_login`, item)])
            .then((responses) => {
                const analysis1 = responses[0];
                return { analysisData: analysis1 };
            })
            .catch((error) => {
                console.error("Error fetching analysis data:", error);
                return { analysisData: {}, analysisData2: {} };
            });
    };

    render() {
        // const { selectProvinceId, selectYear, yearsList, allProvinceList, showProvinceModal, showYearModal, showRegionOptions, tempSelectedRegions, selectionMode } = this.state;
        const {
            xkMode,
            selectedCombinationList,
            selectProvinceId,
            selectYear,
            yearsList,
            allProvinceList,
            emptyProvince,
            selectedGroupList,
            errTips,
            selectionMode,
            scoreTypeList,
            selectedScoreType,
            showScoreModal,
            selectedRegions,
            showRegionOptions,
            tempSelectedRegions,
            showProvinceModal,
            showYearModal,
            tagOptions,
            tempSelectedTags,
            showTagModal,
            selectedTags,
            selectedMajorList,
            selectedSchoolList,
            tempSelectedProvince,
            tempSelectedYear,
            currentExplainItem,
        } = this.state;

        return (
            <div className='xkCoach-wishList-analyze-overview'>
                <div className='page-container'>
                    <div className='banner'>
                        <div className='title'>设置查询条件</div>
                        <div className='content'>
                            为了帮助你选择最适合你的选科组合，我们支持通过设置意向专业、意向院校来分析不同选科组合的可选比例差异，从而帮助你确定与你未来规划最匹配的选科组合。
                        </div>
                    </div>
                    <div className='section-overview'>
                        <div className='content'>
                            <div className='filter'>
                                <div className={emptyProvince ? "score" : "region"}>
                                    <span>
                                        高考省份：
                                        {selectProvinceId
                                            ? allProvinceList.filter((i) => i.id == selectProvinceId)[0] &&
                                              allProvinceList.filter((i) => i.id == selectProvinceId)[0].name
                                            : "不限"}
                                    </span>
                                    <span onClick={this.toggleProvinceOptions}>去修改</span>
                                </div>
                                {emptyProvince && (
                                    <div className='empty-feedback'>当前选择省份暂未录入新高考选科数据，敬请期待。</div>
                                )}
                                <div className='region'>
                                    <span>高考年份：{selectYear || "不限"}年</span>
                                    <span onClick={this.toggleYearOptions}>去修改</span>
                                </div>
                                <div className='region'>
                                    意向专业：
                                    {selectedMajorList.length === 0
                                        ? "不限"
                                        : selectedMajorList.length === 1
                                        ? selectedMajorList[0].name
                                        : `${selectedMajorList[0].name} 等${selectedMajorList.length}个专业`}
                                    <span>
                                        {selectedMajorList.length > 0 && (
                                            <span onClick={this.handleClearMajorSelection} style={{ color: '#334cd5', marginRight: '10px', cursor: 'pointer' }}>
                                                清除
                                            </span>
                                        )}
                                        <span onClick={this.handleMajorWishListClick}>
                                            去修改
                                        </span>
                                    </span>
                                </div>
                                <div className='region'>
                                    <span>院校选择方式：</span>
                                    <div className='radio-group'>
                                        <label className='label'>
                                            <input
                                                type='radio'
                                                name='selection'
                                                value='condition'
                                                checked={selectionMode === "condition"}
                                                onChange={this.handleSelectionModeChange}
                                            />
                                            按条件筛选
                                        </label>
                                        <label className='label'>
                                            <input
                                                type='radio'
                                                name='selection'
                                                value='specific'
                                                checked={selectionMode === "specific"}
                                                onChange={this.handleSelectionModeChange}
                                            />
                                            指定院校
                                        </label>
                                    </div>
                                </div>
                                {selectionMode === "condition" ? (
                                    <div>
                                        <div className='region'>
                                            {/* {"sss"+this.state.selectedRegions.length} */}
                                            院校地区：
                                            {selectedRegions.length > 0
                                                ? allProvinceList
                                                      .filter((i) => selectedRegions.includes(i.id))
                                                      .map((i) => i.name)
                                                      .join("，")
                                                : "不限"}
                                            <span onClick={this.toggleRegionOptions}>去修改</span>
                                        </div>
                                        <div className='region'>
                                            <span>
                                                院校分数：
                                                {selectedScoreType !== 0
                                                    ? `${
                                                          this.state.scoreTypeName[this.state.selectedScoreType]
                                                      }，分数范围：${this.state.selectedMinScore}~${
                                                          this.state.selectedMaxScore
                                                      }`
                                                    : "不限"}
                                            </span>
                                            <span onClick={this.handleEditScore}>去修改</span>
                                        </div>
                                        <div className='region'>
                                            <span>
                                                院校标签：
                                                {selectedTags.length > 0 ? selectedTags.join("，") : "不限"}
                                            </span>
                                            <span onClick={this.toggleTagOptions}>去修改</span>
                                        </div>
                                    </div>
                                ) : (
                                    <div className='region'>
                                        指定院校：
                                        {this.state.selectedSchoolList.length > 0
                                            ? this.state.selectedSchoolList.map((school) => school.name).join(", ")
                                            : "不限"}
                                        <span onClick={this.handleSchoolWishListClick}>去筛选</span>
                                        {/* <button className="select-btn" onClick={this.handleSchoolWishListClick}>院校选择列表</button> */}
                                    </div>
                                )}

                                <div className='score'>
                                    选科组合：
                                    {this.state.selectedCombinationList.length > 0
                                        ? this.state.selectedCombinationList
                                              .map((comb) =>
                                                  comb
                                                      .map((id) => combinationList3_3.find((c) => c.id === id).name)
                                                      .join("+")
                                              )
                                              .join(", ")
                                        : "不限"}
                                    <span onClick={this.handleCombinationeModal}>去修改</span>
                                </div>
                            </div>
                        </div>
                        <button className='submit-btn' disabled={this.submitButtonDisabled}  onClick={this.handleQuery}>
                            开始查询
                        </button>
                    </div>

                    {this.state.showCombinationModal && (
                        <Modal origin='xkCoach'>
                            {xkMode == 1 ? (
                                <div className='show-combination-modal'>
                                    <div className='modal-top'>
                                        <div className='title'>选择要对比的选科组合</div>
                                        <div className='content'>
                                            为了保证对比信息的可读性，你最多
                                            <span>可同时对3个组合</span>
                                            进行对比。如有需要，你也可以随时调整要对比的组合。
                                        </div>
                                        {selectedGroupList.map((i, index) => {
                                            return (
                                                <div className='combination' key={index}>
                                                    <div className='combination-title'>
                                                        <span>科组合{index + 1}</span>
                                                        {index != 0 && (
                                                            <img
                                                                src={deleteIcon}
                                                                alt=''
                                                                onClick={() => {
                                                                    this.handleDeleteGroup(i.index);
                                                                }}
                                                            />
                                                        )}
                                                    </div>
                                                    <div className='combination-options'>
                                                        {combinationList3_3.map((c, indexc) => {
                                                            return (
                                                                <div
                                                                    className='item'
                                                                    key={indexc}
                                                                    onClick={() => {
                                                                        this.handleClickCombination_3_3(c.id, index);
                                                                    }}>
                                                                    <img
                                                                        src={
                                                                            i.id.includes(c.id)
                                                                                ? selectedImg
                                                                                : unSelectImg
                                                                        }
                                                                        alt=''
                                                                    />
                                                                    {c.name}
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                        {selectedGroupList.length < 3 && (
                                            <div className='btn-add' onClick={this.handleAddGroup}>
                                                <img src={addIcon} alt='' />
                                                添加组合
                                            </div>
                                        )}
                                        {errTips && <div className='tips'>提示：{errTips}</div>}
                                    </div>
                                    <div className='modal-bottom'>
                                        <div
                                            className='btn cancel'
                                            onClick={() => {
                                                this.setState({
                                                    showCombinationModal: false,
                                                });
                                            }}>
                                            取消
                                        </div>
                                        <div className='btn confirm' onClick={this.handleConfirm_3_3}>
                                            确定
                                        </div>
                                    </div>
                                </div>
                            ) : xkMode == 2 ? (
                                <div className='show-combination-modal'>
                                    <div className='modal-top'>
                                        <div className='title'>选择要对比的选科组合</div>
                                        <div className='content'>
                                            为了保证对比信息的可读性，你最多
                                            <span>可同时对3个组合</span>
                                            进行对比。如有需要，你也可以随时调整要对比的组合。
                                        </div>
                                        {combinationList.map((i, index) => (
                                            <div className='combination' key={index}>
                                                <div className='combination-title'>{i.title}</div>
                                                <div className='combination-options'>
                                                    {i.children.map((c, indexc) => (
                                                        <div
                                                            className='item'
                                                            key={indexc}
                                                            onClick={() => this.handleClickCombination_3_1_2(c.id)}>
                                                            <img
                                                                src={
                                                                    this.state.selectedCombinationList.some(
                                                                        (comb) =>
                                                                            JSON.stringify(comb) ===
                                                                            JSON.stringify(c.id)
                                                                    )
                                                                        ? selectedImg
                                                                        : unSelectImg
                                                                }
                                                                alt=''
                                                            />
                                                            {c.name}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        ))}
                                        {this.state.showMaximumLimit && (
                                            <div className='tips'>提示：最多选择3个组合</div>
                                        )}
                                    </div>
                                    <div className='modal-bottom'>
                                        <div
                                            className='btn cancel'
                                            onClick={() => {
                                                this.setState({
                                                    showCombinationModal: false,
                                                });
                                            }}>
                                            取消
                                        </div>
                                        <div className='btn confirm' onClick={this.handleConfirm_3_1_2}>
                                            确定
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className='show-combination-modal'>
                                    <div className='modal-top'>
                                        <div className='title'>选择要对比的选科组合</div>
                                        <div className='content'>
                                            为了保证对比信息的可读性，你最多
                                            <span>可同时对3个组合</span>
                                            进行对比。如有需要，你也可以随时调整要对比的组合。
                                        </div>
                                        {selectedGroupList.map((i, index) => {
                                            return (
                                                <div className='combination' key={index}>
                                                    <div className='combination-title'>
                                                        <span>科组合{index + 1}</span>
                                                        {index != 0 && (
                                                            <img
                                                                src={deleteIcon}
                                                                alt=''
                                                                onClick={() => {
                                                                    this.handleDeleteGroup(i.index);
                                                                }}
                                                            />
                                                        )}
                                                    </div>
                                                    <div className='combination-options'>
                                                        {combinationList7_3.map((c, indexc) => {
                                                            return (
                                                                <div
                                                                    className='item'
                                                                    key={indexc}
                                                                    onClick={() => {
                                                                        this.handleClickCombination_3_3(c.id, index);
                                                                    }}>
                                                                    <img
                                                                        src={
                                                                            i.id.includes(c.id)
                                                                                ? selectedImg
                                                                                : unSelectImg
                                                                        }
                                                                        alt=''
                                                                    />
                                                                    {c.name}
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                        {selectedGroupList.length < 3 && (
                                            <div className='btn-add' onClick={this.handleAddGroup}>
                                                <img src={addIcon} alt='' />
                                                添加组合
                                            </div>
                                        )}
                                        {errTips && <div className='tips'>提示：{errTips}</div>}
                                    </div>
                                    <div className='modal-bottom'>
                                        <div
                                            className='btn cancel'
                                            onClick={() => {
                                                this.setState({
                                                    showCombinationModal: false,
                                                });
                                            }}>
                                            取消
                                        </div>
                                        <div className='btn confirm' onClick={this.handleConfirm_3_3}>
                                            确定
                                        </div>
                                    </div>
                                </div>
                            )}
                        </Modal>
                    )}

                    {showScoreModal && (
                        <Modal
                            origin='xkCoachBottom'
                            onCancel={() => {
                                this.setState({ showScoreModal: false });
                            }}>
                            <div className='show-score-modal'>
                                <div className='modal-title'>
                                    筛选院校的录取分数
                                    <svg
                                        t='1676039031388'
                                        className='icon'
                                        viewBox='0 0 1024 1024'
                                        version='1.1'
                                        xmlns='http://www.w3.org/2000/svg'
                                        p-id='10861'
                                        width='16'
                                        height='16'
                                        onClick={() => {
                                            this.setState({
                                                showScoreModal: false,
                                            });
                                        }}>
                                        <path d='M511.232 438.8352L112.9984 40.6016A51.2 51.2 0 0 0 40.6016 112.9984L438.784 511.232 40.6016 909.4656a51.2 51.2 0 1 0 72.3968 72.448l398.2336-398.2848 398.2336 398.2848a51.2 51.2 0 1 0 72.448-72.448l-398.2848-398.2336 398.2848-398.2336A51.2 51.2 0 0 0 909.4656 40.601'></path>
                                    </svg>
                                </div>
                                <div className='modal-center'>
                                    {scoreTypeList.length === 1 ? (
                                        <div className='loading'>正在读取数据...</div>
                                    ) : (
                                        <div className='modal-center-top'>
                                            <span>分数范围：</span>
                                            {scoreTypeList.map((i, index) => {
                                                return (
                                                    <span
                                                        key={index}
                                                        className={`${selectedScoreType == i.id ? "bold-remind" : ""}`}
                                                        onClick={() => this.handleSelectScoreType(i.id)}>
                                                        <img
                                                            src={
                                                                selectedScoreType == i.id
                                                                    ? radioCheckedImg
                                                                    : radioDefultImg
                                                            }
                                                            alt=''
                                                        />
                                                        {i.name}
                                                    </span>
                                                );
                                            })}
                                        </div>
                                    )}

                                    {selectedScoreType != 0 && scoreTypeList.length !== 1 && (
                                        <div className='modal-center-bottom' id='slider-containers'>
                                            <div className={`bottom-title ${selectedScoreType != 0 ? "" : "noScore"}`}>
                                                范围选择：
                                            </div>
                                            <Slider
                                                range
                                                value={this.state.scoreRange}
                                                max={this.state.scoreMax}
                                                min={this.state.scoreMin}
                                                tooltipVisible
                                                tooltipPlacement='top'
                                                tipFormatter={(e) => this.sliderFormatter(e)}
                                                onChange={(e) => {
                                                    this.setState({
                                                        scoreRange: e,
                                                    });
                                                }}
                                                getTooltipPopupContainer={() =>
                                                    document.getElementById("slider-containers")
                                                }
                                            />
                                            <span className='legend'>拖动圆点选择「分数/省排名」范围</span>
                                        </div>
                                    )}
                                </div>
                                <div className='modal-bottom'>
                                    <div
                                        className='btn cancel'
                                        onClick={() => {
                                            this.setState({
                                                selectedScoreType: 0,
                                            });
                                        }}>
                                        重置
                                    </div>
                                    <div className='btn confirm' onClick={this.handleConfirmScore}>
                                        确定
                                    </div>
                                </div>
                            </div>
                        </Modal>
                    )}
                    {showProvinceModal && (
                        <ProvinceModal
                            allProvinceList={allProvinceList}
                            tempSelectedProvince={tempSelectedProvince}
                            handleProvinceChange={this.handleProvinceChange}
                            closeProvinceOptions={this.toggleProvinceOptions}
                            confirmProvinceSelection={this.confirmProvinceSelection}
                        />
                    )}

                    {showYearModal && (
                        <YearModal
                            selectYear={selectYear}
                            yearsList={[2026, ...yearsList]}
                            tempSelectedYear={tempSelectedYear}
                            handleYearChange={this.handleYearChange}
                            closeYearOptions={this.toggleYearOptions}
                            confirmYearSelection={this.confirmYearSelection}
                        />
                    )}
                    {showRegionOptions && (
                        <RegionModal
                            allProvinceList={allProvinceList}
                            tempSelectedRegions={tempSelectedRegions}
                            handleRegionToggle={this.handleRegionToggle}
                            closeRegionOptions={this.closeRegionOptions}
                            confirmRegionSelection={this.confirmRegionSelection}
                        />
                    )}
                    {showTagModal && (
                        <TagModal
                            tagOptions={tagOptions}
                            tempSelectedTags={tempSelectedTags}
                            handleTagToggle={this.handleTagToggle}
                            closeTagOptions={this.closeTagOptions}
                            confirmTagSelection={this.confirmTagSelection}
                        />
                    )}
                    {this.state.showExplainModal && (
                        <Modal origin='xkCoach'>
                            <div className='show-explain-modal'>
                                <div className='title'>{currentExplainItem.title}</div>
                                <div
                                    className='content'
                                    dangerouslySetInnerHTML={{
                                        __html: currentExplainItem.content.replace(/\\n/g, "<br/>"),
                                    }}
                                />
                                <div
                                    className='btn'
                                    onClick={() => {
                                        this.setState({
                                            showExplainModal: false,
                                        });
                                    }}>
                                    知道了
                                </div>
                            </div>
                        </Modal>
                    )}
                </div>
            </div>
        );
    }
}

export default withRouter(SelectSubject);



// WEBPACK FOOTER //
// ./src/pages/SelectSubject/SelectSubject.js